//da completare quando vengono
import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  filters: {
    pageIndex: 1,
    pageSize: 12,
    globalSearch: "",
    type: null,
    sorting: null,
  },
  hasNextPage: true,
  loading: false,
  firstLoad: true,
  projects: {
    pageNumber: 0,
    totalPages: 0,
    totalCount: 0,
    items: [],
  },
  currentProject: null,
  loadedPanel: true,
};
const gestioneProjectsSlice = createSlice({
  name: "gestioneProjectsSlice",
  initialState,
  reducers: {
    setSearchTermProject: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        globalSearch: action.payload,
      });
    },
    setTypeProject: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        type: action.payload,
      });
    },
    setPageProjects: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload,
      });
    },
    setSortProject: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        sorting: action.payload,
      });
    },
    setProjects: (state: any, action: any) => {
      state.projects = action.payload;
    },
    addProjects: (state: any, action: any) => {
      state.projects.items = [...state.projects.items, ...action.payload];
    },
    updatePreferredProjectStatus: (state: any, action: any) => {
      state.projects.items = state.projects.items.map((item: any) => {
        if (item.id === action.payload.id) {
          item.isPreferred = action.payload.preferred;
        }
        return item;
      });
    },
    updateProjectName: (state: any, action: any) => {
      state.projects.items = state.projects.items.map((item: any) => {
        if (item.id === action.payload.id) {
          item.name = action.payload.name;
          gestioneProjectsSlice.caseReducers.setCurrentProject(state, {
            payload: item,
          });
        }
        return item;
      });
    },
    UpdateProject: (state: any, action: any) => {
      state.currentProject = JSON.parse(JSON.stringify(action.payload));
      state.projects.items = state.projects.items.map((item: any) => {
        if (item.id === action.payload.id) {
          item.type = action.payload.type;
        }
        return item;
      });
    },
    resetProjectsState() {
      return initialState;
    },
    setCurrentProject: (state: any, action: any) => {
      state.currentProject = action.payload;
    },
    setHasNextPageProjects: (state, action) => {
      state.hasNextPage = action.payload;
    },
    nextPageProjects: (state) => {
      state.filters.pageIndex++;
    },
    setLoadingProjects: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingPanelProjects: (state, action) => {
      state.loadedPanel = action.payload;
    },
    setFirstLoadProjects: (state, action) => {
      state.firstLoad = action.payload;
    },
    resetState: (state) => {
      const { currentProject } = state;
      return {
        ...initialState,
        currentProject,
      };
    },
  },
});

export const {
  setProjects,
  addProjects,
  setSearchTermProject,
  setSortProject,
  setPageProjects,
  setTypeProject,
  resetProjectsState,
  updatePreferredProjectStatus,
  updateProjectName,
  setCurrentProject,
  UpdateProject,
  setHasNextPageProjects,
  nextPageProjects,
  setLoadingProjects,
  setFirstLoadProjects,
  setLoadingPanelProjects,
  resetState,
} = gestioneProjectsSlice.actions;

export default gestioneProjectsSlice.reducer;
